export default __webpack_public_path__ + "static/idriss-full-d18c06a796cef88aa21d16671239ea2b.png";